<!--阅卷记录-->
<template>
	<div class="history-board-wrap">
		<div class="history-board" ref="board">
			<div class="record-history">
				<div class="account">
					阅卷记录：<span class="record-total">{{ sumHistory }}</span>
					<span class="score">
						平均分:{{ averageScore }}
						<i class="iconfont iconcha" @click="closeHistoryBoard"></i>
					</span>
				</div>
				<el-row type="flex" justify="space-between" style="margin: 3px 0">
					<el-col :span="24">
						<el-input placeholder="请输入学生得分" v-model.number="studentScore" @keyup.enter.native="searchScore" size="mini" clearable>
							<el-button type="primary" size="mini" slot="append" @click="searchScore">搜索</el-button>
						</el-input>
					</el-col>
				</el-row>
				<el-table
					:data="tableHistory"
					ref="tableRef"
					style="width: 100%"
					:row-class-name="tableRowClassName"
					@row-click="getTableHistoryRecord"
					@current-change="handleCurrentChange"
					highlight-current-row
					stripe
					border
				>
					<el-table-column prop="studentId" label="ID" width="75" align="center"> </el-table-column>
					<el-table-column prop="score" label="得分" width="50" align="center">
						<template slot-scope="scope">
							<span style="color: red">{{ scope.row.score }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="type" label="状态" width="70" align="center">
						<template slot-scope="scope"><span v-text="operateType(scope)"></span></template>
					</el-table-column>
					<el-table-column prop="updateDate" label="阅卷时间" align="center" show-overflow-tooltip> </el-table-column>
					<el-table-column prop="markName" label="阅卷账户" align="center" show-overflow-tooltip> </el-table-column>
				</el-table>
				<el-pagination
					layout="prev, pager, next"
					@current-change="tableCurrentChange"
					:total="tableHistoryTotal"
					:page-size="5"
					:current-page="tableCurrentPage"
				>
				</el-pagination>
			</div>
			<div class="score-history">
				<div class="account">打分记录：</div>
				<el-table :data="tableHistoryRecord" :row-class-name="recordClassName" stripe border>
					<el-table-column prop="studentId" label="ID" align="center" width="65" show-overflow-tooltip> </el-table-column>
					<el-table-column prop="score" label="得分" align="center" width="50" show-overflow-tooltip>
						<template slot-scope="scope">
							<span :class="{ 'show-del': scope.row.deleted === 1 }">{{ scope.row.score }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="updateDate" label="阅卷时间" align="center" show-overflow-tooltip> </el-table-column>
					<el-table-column prop="markName" label="阅卷账户" align="center" show-overflow-tooltip> </el-table-column>
					<el-table-column prop="allMarks" label="得分明细" align="center" show-overflow-tooltip> </el-table-column>
				</el-table>
				<el-pagination
					layout="prev, pager, next"
					@current-change="recordCurrentChange"
					:total="tableHistoryRecordTotal"
					:page-size="3"
					:current-page="recordCurrentPage"
				>
				</el-pagination>
			</div>
		</div>
		<guide
			class="history-score-board"
			title="阅卷记录"
			v-if="guideStepVal === 11"
			distribute="个人阅卷记录和某张试卷的打分记录（双评）"
			:isTopArr="false"
			:isShowNext="false"
		/>
	</div>
</template>

<script>
import drag from '../../../mixin/drag-mixin'
import guideMixin from '../utils/guide-mixin'
export default {
	name: 'history-record-board',
	mixins: [drag, guideMixin],
	components: { guide: () => import('./guide') },
	props: {
		guideStepVal: {
			type: Number,
			default: -1
		}
	},
	watch: {
		guideStepVal: {
			handler(val) {
				this.guideStep = val
			},
			immediate: true
		}
	},
	data() {
		return {
			//阅卷记录  当前页
			tableCurrentPage: 1,
			//打分记录 当前页
			recordCurrentPage: 1,
			query: this.$route.query,
			// 阅卷记录 列表
			tableHistory: [],
			//阅卷记录 sum
			tableHistoryTotal: 0,
			//打分记录 列表
			tableHistoryRecord: [],
			//打分记录 sum
			tableHistoryRecordTotal: 0,
			//阅卷记录  获取某一条
			currentRowVal: {},
			//基本信息
			basicInfo: {},
			//阅卷记录 梳理蓝
			sumHistory: 0,
			//阅卷记录 当前页
			currentHistoryIndex: -1,
			// 位置
			dragStartX: -25,
			dragStartY: 0,
			rotateDegree: 0,
			scaleState: 1,
			studentScore: null,
			//平均分
			averageScore: 0
		}
	},
	created() {
		this.getScreenWidth()
	},
	mounted() {
		this.getTableHistory()
		this.watchCurrentCompEmit()
		this.$nextTick(() => {
			this.dragStartY = document.body.clientHeight - this.$refs['board'].clientHeight - 100
			this.$refs['board'].style.transform = `translateX(${this.dragStartX}px) translateY(${this.dragStartY}px)`
		})
	},
	methods: {
		// 搜索得分情况
		searchScore() {
			this.tableCurrentPage = 1
			this.getTableHistory(this.studentScore)
		},
		// 屏幕宽度
		getScreenWidth() {
			if (window.screen.width < 1920) {
				this.dragStartX = -35
			}
		},
		//设置table 字段
		operateType(scope) {
			if (scope.row.type === 0) {
				return '初评'
			} else if (scope.row.type === 1) {
				return '典型卷'
			} else if (scope.row.type === 2) {
				return '疑难卷'
			} else if (scope.row.type === 3) {
				return '终评'
			}
		},
		// 打分记录 设置状态
		recordClassName({ row }) {
			if (row.deleted === 0) return 'success-row'
			return ''
		},
		//阅卷记录
		handleCurrentChange(val) {
			this.currentHistoryIndex = val?.index ?? -1
			this.$refs.tableRef.setCurrentRow(val)
		},
		//eventbus
		watchCurrentCompEmit() {
			this.eventBus.$on('basicInformation', cb => {
				this.basicInfo = cb
			})
			this.eventBus.$on('historyNextPaper', () => {
				const index = this.currentHistoryIndex + 1 >= this.tableHistory.length - 1 ? this.tableHistory.length - 1 : this.currentHistoryIndex + 1
				this.$refs['tableRef'].setCurrentRow(this.tableHistory[index])
				this.getTableHistoryRecord(this.tableHistory[index])
			})
			this.eventBus.$on('historyPrevPaper', () => {
				const index = this.currentHistoryIndex - 1 <= 0 ? 0 : this.currentHistoryIndex - 1
				this.$refs['tableRef'].setCurrentRow(this.tableHistory[index])
				this.getTableHistoryRecord(this.tableHistory[index])
			})
		},
		// 关闭历史board
		closeHistoryBoard() {
			this.eventBus.$emit('historyBoardState', false)
			localStorage.removeItem('finalCanNotExam')
		},
		// 获取阅卷记录
		async getTableHistory(score = null) {
			const params = {
				examId: this.query.examId,
				examSubjectId: this.query.examSubjectId,
				paperTextTaskId: this.query.paperTextTaskId,
				type: this.query.type
			}
			const historyParams = Object.assign({}, params, {
				page: this.tableCurrentPage,
				limit: 5,
				score: score
			})
			this.$post('examAnswerMarking/markingHistoryList', historyParams).then(res => {
				this.eventBus.$emit('startTime', new Date().getTime())
				this.sumHistory = res.total
				this.tableHistory = res.data
				this.tableHistoryTotal = res.total
			})

			this.$post('examAnswerMarking/markingHistoryListAvgScore', params).then(resp => {
				this.averageScore = resp.data
			})
		},
		// 在row中添加索引
		tableRowClassName({ row, rowIndex }) {
			row.index = rowIndex
		},
		// 获取打分记录
		getTableHistoryRecord(row) {
			const params = {
				examId: this.query.examId,
				examSubjectId: this.query.examSubjectId,
				paperTextTaskId: this.query.paperTextTaskId,
				studentId: row.studentId,
				type: -4,
				page: this.recordCurrentPage,
				limit: 3
			}
			this.currentRowVal = row
			this.markingHistoryList(params, row).then(res => {
				localStorage.setItem('finalCanNotExam', '0')
				res.data.forEach(element => {
					if (element.markName.includes('[终评]') && this.query.type === '0' && element.deleted === 0) {
						this.$message({ message: '当前试卷，已终评，不能再修改分数！', type: 'error', duration: 3000 })
						localStorage.setItem('finalCanNotExam', '1')
						return false
					}
					if (element.deleted == 0 && element.updateId == this.query.userId && this.recordCurrentPage == 1) {
						this.getImageUrlByMark(row, element)
					}
				})
				let isTypical = false
				if (row.type === 1) isTypical = true
				this.eventBus.$emit('isTypical', { state: isTypical, text: row.remark })
			})
			this.eventBus.$emit('isHistoryState', true)
			this.eventBus.$emit('isShowAutoSubmit', false)
			this.eventBus.$emit('markBoardState', true)
			this.eventBus.$emit('isDisplayMarkScoreBoard', true)
			this.eventBus.$emit('imgAddrListInfo', { imgAddrList: JSON.parse(row.imgAddr).imgAddr })
			this.eventBus.$emit('historyToScoreSingle')
		},
		// 获取阅卷记录
		async markingHistoryList(params) {
			return this.$post('examAnswerMarking/markingHistoryList', params).then(res => {
				this.eventBus.$emit('startTime', new Date().getTime())
				this.tableHistoryRecord = []
				let userFulIndex = 0
				res.data.forEach((resp, index) => {
					this.tableHistoryRecord.push(resp)
					let resultMark = ''
					JSON.parse(resp.marks).forEach(response => {
						resultMark = resultMark + response.textTopic + '得' + response.score + '分, '
					})
					this.tableHistoryRecord[index].allMarks = resultMark
					if (resp.deleted === 0 && resp.updateId === this.query.userId) {
						userFulIndex = index
					}
				})

				this.tableHistoryRecordTotal = res.total
				const imgAddrList = JSON.parse(res.data[userFulIndex].imgAddr)
				let isHorizontalImage = false
				let imgAddr = {}
				if (Object.keys(imgAddrList).length > 0) {
					isHorizontalImage = imgAddrList.isHorizontalImage
					imgAddr = imgAddrList.imgAddr
				}
				this.eventBus.$emit('deviceName', imgAddrList.deviceName)
				this.eventBus.$emit('horizontalChange', isHorizontalImage)
				this.eventBus.$emit('imgAddrListInfo', { imgAddrList: imgAddr })
				this.eventBus.$emit('historyBoardState', true)
				this.eventBus.$emit('markBoardState', true)
				this.eventBus.$emit('scoreBoardState', false)
				this.eventBus.$emit('isScoreBoardState', false)
				let isFastScoreState = false
				if (Object.keys(imgAddrList).length > 0 && Object.keys(imgAddrList.imgAddr).length > 0 && this.recordCurrentPage === 1) {
					const remarks = imgAddrList.imgAddr
					const remarkKey = Object.keys(remarks)[0]
					const firstScoreState = remarks[remarkKey][0][2]
					if (firstScoreState) {
						this.eventBus.$emit('changeFastScoreInfo', { key: firstScoreState.slice(0, 1), val: Number(firstScoreState.slice(1)) })
					}
					isFastScoreState = imgAddrList.isFastScore
				}
				this.eventBus.$emit('isFastScoreState', isFastScoreState)
				return res
			})
		},
		// 获取打分记录，并获取到打分的图片
		getImageUrlByMark(row, basicInfo) {
			const params = {
				examId: this.query.examId,
				examSubjectId: this.query.examSubjectId,
				paperTextTaskId: this.query.paperTextTaskId,
				studentId: row.studentId,
				examAnswerMarkingId: row.pkId,
				markingTaskId: this.query.markingTaskId,
				type: 0,
				minute: 10
			}
			this.$post('examImgInfo/getImageUrlByMark', params).then(res => {
				this.eventBus.$emit('examUrlInfo', { urls: res.data.urls })
				// this.eventBus.$emit('markList', { markList: basicInfo.imgAddr })
				let scoreList = []
				res.data.textPaperScores.forEach((responce, index) => {
					let getScore = JSON.parse(basicInfo.marks)[index].score
					scoreList.push(Object.assign({}, responce, { getScore }))
				})
				this.eventBus.$emit('isFastScoreState', JSON.parse(basicInfo.imgAddr).isFastScore)
				this.eventBus.$emit('horizontalChange', JSON.parse(basicInfo.imgAddr).isHorizontalImage)
				this.eventBus.$emit('emitScoreList', scoreList)
				this.eventBus.$emit(
					'basicInformation',
					Object.assign({}, basicInfo, { examAnswerMarkingId: row.pkId, markingImageId: res.data.markingImageId })
				)
			})
		},
		// 阅卷记录 分页
		tableCurrentChange(page) {
			this.tableCurrentPage = page
			this.getTableHistory(this.studentScore)
		},
		// 打分记录 分页
		recordCurrentChange(page) {
			this.recordCurrentPage = page
			this.getTableHistoryRecord(this.currentRowVal)
		}
	}
}
</script>

<style lang="less">
.history-board {
	width: 480px;
	background: white;
	position: absolute;
	right: 0;
	top: 0;
	cursor: move;
	padding: 5px 10px 5px;
	box-sizing: border-box;
	border-radius: 8px;
	box-shadow: 0 0 10px rgb(185, 180, 180);
	z-index: 7;
	//@media screen and (max-width: 1920px) {
	//	width: 436px;
	//}
	.account {
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		color: #ff7200;
		@media screen and (max-width: 1920px) {
			height: 25px;
			line-height: 25px;
			font-size: 15px;
		}
		.record-total {
			background: #ff7200;
			color: white;
			font-size: 11px;
			padding: 1px 6px;
			border-radius: 4px;
		}
		.score {
			float: right;
		}

		.iconfont {
			color: #909399;
			cursor: pointer;
			margin-left: 20px;
		}
	}
	.score-history {
		margin-top: 5px;
	}
	.show-del {
		text-decoration: line-through;
	}
	/deep/.el-table td,
	.el-table th {
		padding: 5px 0;
	}
	/deep/.el-input-group__append {
		background: #009688;
		border: 1px solid #009688;
		color: white;
	}
}
.el-table__body tr.current-row > td {
	background-color: #009688 !important;
	color: #fff;
}
.el-table .success-row {
	color: black;
	td {
		background: #eaeaea !important;
	}
}
</style>
